<template>
    <div id="payment-wait-flyin" class="payment-wait-flyin">
        <h3>
            {{ resources.flyin.title }}
        </h3>
        <div class="js-payment-wait-text payment-wait-text">
            {{ text }}
            <span class="ico" :class="icon"></span>
        </div>
        <footer class="payment-wait-footer">
            <button type="button" class="btn" @click="closeFlyin()">
                {{ resources.flyin.buttonLabel }}
            </button>
        </footer>

    </div>
</template>

<script src='./payment-wait-flyin.js'></script>
